export const ClientName = {
  N12: 'n12',
  MAKO: 'mako',
} as const;

export const REPORT_OPTIONS: Record<string, string> = {
  'option-1': 'מתקפת זהות',
  'option-2': 'דברי שטנה',
  'option-4': 'אחר',
};
